import { GameSettingType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { CrossIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";
import { usePlayerMenuStore } from "@/domains/playerMenu/store";
import { getOpacity } from "@/domains/playerMenu/helpers/getOpacity";
import PlayerMenuHeaderTab from "@/domains/playerMenu/components/header/PlayerMenuHeaderTab";
import PlayerMenuLocalization from "@/domains/playerMenu/components/header/PlayerMenuLocalization";
import { appliedBasicSettingsSelector } from "@/domains/settings/basic/slice";

export default function PlayerMenuHeaderContainer() {
  const { t } = useTranslation("playerMenu");
  const appliedBasicSettings = useAppSelector(appliedBasicSettingsSelector);
  const { headerTabs, currHeaderTab, changeHeaderTab } = usePlayerMenuStore();

  const closeHandler = useCallback(() => {
    GameMpProvider.closeCurrentInterface();
  }, []);

  const opacity = useMemo(
    () =>
      appliedBasicSettings
        ? getOpacity(appliedBasicSettings[GameSettingType.SettingMainMenuTransparency])
        : 1,
    [appliedBasicSettings],
  );

  return (
    <div
      className="h-[5.875rem] flex items-stretch border-b  pr-7.5"
      style={{
        backgroundImage: `
        linear-gradient(122deg, rgba(215, 52, 52, ${0.3 * opacity}) 0%, transparent 20%)
        `,
        borderColor: `rgb(24 24 24 / ${0.5 * opacity})`,
      }}
    >
      <PlayerMenuLocalization />
      <div
        className="flex items-stretch gap-7.5 px-10 border-l"
        style={{
          borderColor: `rgb(24 24 24 / ${0.5 * opacity})`,
        }}
      >
        {headerTabs.map((item) => (
          <PlayerMenuHeaderTab
            key={item}
            onClick={() => changeHeaderTab(item)}
            label={t(`playerMenu.headerTab.${item}`)}
            isActive={item === currHeaderTab}
          />
        ))}
      </div>
      <div className="flex items-center gap-5 ml-auto">
        <div className="text-12 font-extrabold text-white/60">
          ESC <span className="text-white/30">ЗАКРЫТЬ</span>
        </div>
        <SoundButton
          variant="soft"
          color="gray"
          className="h-[2rem] aspect-square shrink-0 p-0"
          onClick={closeHandler}
        >
          <CrossIcon size={10} />
        </SoundButton>
      </div>
    </div>
  );
}
